import { $host } from ".";

export const fetchCategories = async () => {
    try {
        const { data } = await $host.get('api/category');
        return data;
    } catch (error) {
        console.error("Error fetching categories:", error);
        return error;
    }
};